const html = require('choo/html');
const progressBar = require('../elements/progress_bar');
const yesNoQuestion = require('../elements/yes_no_question');
const MultiselectMultipleChoice = require('../components/multiselect_multiple_choice');
const TITLE = 'Can You Spot the Terrorist';
const QUESTION_TYPES = require('../lib/question_types');
const multipleChoiceQuestion = require('../elements/multiple_choice_question');

module.exports = view;

function question(state, emit) {
  if (!state || !state.type) {
    return html`
      <div>Something went really, really wrong</div>
    `;
  }
  switch (state.type) {
    case QUESTION_TYPES.YES_NO:
      return yesNoQuestion(state, emit);
    case QUESTION_TYPES.MULTIPLE_CHOICE:
      return multipleChoiceQuestion(state, emit);
    case QUESTION_TYPES.MULTISELECT_MULTIPLE_CHOICE:
      const multiselect = new MultiselectMultipleChoice(emit);
      return html`
        <div>${multiselect.render(state)}</div>
      `;
    // return new MultiselectMultipleChoice(state.id, state, emit).render;
    default:
      return html`
        <div>Haven't implemented question type</div>
      `;
  }
}

function view(state, emit) {
  if (state.title !== TITLE) emit(state.events.DOMTITLECHANGE, TITLE);
  return html`
    <div id="app" class="center mw8-ns lh-copy ti-sans navy">
      <main class="cf">
        ${progressBar(state)} ${question(state.currentQuestion, emit)}
      </main>
    </div>
  `;
}
